import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Table = memo((props: IconProps) => {
    const { color = "var(--tipografa)", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 50 45" fill="none" {...rest}>
            <path
                fill={color}
                d="M.202 12.342V9.143c.05-2.42 2.382-4.024 4.265-4.977 3.224-1.632 6.836-2.436 10.37-2.967 4.685-.702 9.449-.89 14.18-.628 4.181.234 8.419.782 12.446 2.003 1.54.468 3.063 1.039 4.48 1.809 1.031.56 2.078 1.261 2.826 2.197.576.719.958 1.54 1.008 2.431a.91.91 0 0 1 .016.177c0 1.272.017 2.55 0 3.823-.022 1.672-1.157 2.95-2.398 3.886-1.712 1.29-3.8 2.077-5.81 2.7-2.814.867-5.728 1.375-8.647 1.711-1.734.2-3.479.331-5.223.383v13.044c2.298.263 4.741.845 6.536 2.357.709.6 1.257 1.45 1.28 2.42.022.89-.45 1.717-1.064 2.31-.787.76-1.773 1.25-2.77 1.627-1.252.48-2.564.742-3.883.907-2.841.366-5.854.223-8.618-.599-1.878-.559-4.675-1.752-4.753-4.142v-.12c.039-1.199.825-2.112 1.734-2.768 1.14-.827 2.548-1.301 3.894-1.62.72-.172 1.451-.292 2.188-.377V21.684a60.434 60.434 0 0 1-2.87-.148c-3.085-.246-6.17-.674-9.172-1.433-2.255-.565-4.537-1.306-6.564-2.494-1.385-.81-2.847-1.957-3.329-3.6-.138-.542-.122-1.102-.122-1.667Z"
            />
        </svg>
    )
})

export default Table
